import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, LocPortal } from '@cm/core/localization';

const pathStart = 'Share|Transcripts|Email Transcript Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.ShareTranscriptSendEmails,
	htmlAllowed: false,
	portal: 'CP' as LocPortal,
};

export type CPEmailTranscriptModalLocNames =
	| 'CPEmailTranscriptModalTitle'
	| 'CPEmailTranscriptModalLabelRecipientEmail'
	| 'CPEmailTranscriptModalLabelLanguage'
	| 'CPEmailTranscriptModalNoLanguagesAvailable'
	| 'CPEmailTranscriptModalErrorEmailRequired'
	| 'CPEmailTranscriptModalErrorInvalidEmail'
	| 'CPEmailTranscriptModalErrorLanguageRequired'
	| 'CPEmailTranscriptModalButtonCancel'
	| 'CPEmailTranscriptModalButtonSend';

export const cpEmailTranscriptModalLocs: LocDefs<CPEmailTranscriptModalLocNames> = {
	CPEmailTranscriptModalTitle: {
		defaultValue: 'Email Transcript',
		description: 'Title for the email transcript modal dialog',
		displayPath: `${pathStart}Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	CPEmailTranscriptModalLabelRecipientEmail: {
		defaultValue: 'Recipient Email Address',
		description: 'Label for the recipient email address field',
		displayPath: `${pathStart}Recipient Email Label`,
		displayType: 'Label',
		...sharedProperties,
	},
	CPEmailTranscriptModalLabelLanguage: {
		defaultValue: 'Language',
		description: 'Label for the language selection field',
		displayPath: `${pathStart}Language Label`,
		displayType: 'Label',
		...sharedProperties,
	},
	CPEmailTranscriptModalNoLanguagesAvailable: {
		defaultValue: 'No languages available',
		description: 'Shown in the language dropdown when no email transcript languages are available',
		displayPath: `${pathStart}No Languages Available`,
		displayType: 'Content',
		...sharedProperties,
	},
	CPEmailTranscriptModalErrorEmailRequired: {
		defaultValue: 'Email address is required',
		description: 'Error message when email field is empty',
		displayPath: `${pathStart}Email Required Error`,
		displayType: 'Error',
		...sharedProperties,
	},
	CPEmailTranscriptModalErrorInvalidEmail: {
		defaultValue: 'Please enter a valid email address',
		description: 'Error message when email format is invalid',
		displayPath: `${pathStart}Invalid Email Error`,
		displayType: 'Error',
		...sharedProperties,
	},
	CPEmailTranscriptModalErrorLanguageRequired: {
		defaultValue: 'Language is required',
		description: 'Error message when language field is not selected',
		displayPath: `${pathStart}Language Required Error`,
		displayType: 'Error',
		...sharedProperties,
	},
	CPEmailTranscriptModalButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button in the email transcript modal',
		displayPath: `${pathStart}Cancel Button`,
		displayType: 'Button',
		...sharedProperties,
	},
	CPEmailTranscriptModalButtonSend: {
		defaultValue: 'Send Email',
		description: 'Send button in the email transcript modal',
		displayPath: `${pathStart}Send Button`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type CPEmailTranscriptModalLocType = LocMap<CPEmailTranscriptModalLocNames>;
